import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        { text: 'تاریخ', value: 'date', align: 'center', isGroupable: true },
        { text: 'از', value: 'from', align: 'center', isGroupable: true },
        { text: 'به', value: 'to', align: 'center', isGroupable: true },
        { text: 'کاربر', value: 'user', align: 'center', isGroupable: true },
        {
          text: 'مدت زمان',
          value: 'duration',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'مدت انتظار',
          value: 'waitTime',
          align: 'center',
          isGroupable: true,
        },
        { text: 'وضعیت', value: 'status', align: 'center', isGroupable: true },
        {
          text: 'قطع کننده',
          value: 'hangSide',
          align: 'center',
          isGroupable: true,
        },
        { text: 'عملیات', value: 'actions', align: 'center', sortable: false },
      ],

      searchFromDate: '',
      searchToDate: '',
      searchCallTagId: null,
      searchSource: '',
      searchDestination: '',
      tableItems: [],
      recordFile: '',
      player: false,
      searchUserId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      downloadVoicePermission: false,
      listenVoicePermission: false,
      callsTotalPages: 1,
      pagination: {
        PageNumber: 1,
        PageSize: 10,
      },
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        let hangSide = '';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        let duration1 = null;
        if (data[i].callLog) {
          duration1 = Math.round(data[i].callLog.holdTime);
          duration1 = duration1 * 1000;
        }
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].user) {
          user += data[i].user.firstName ? data[i].user.firstName : '-';
          user += ' ';
          user += data[i].user.lastName ? data[i].user.lastName : '-';
        }
        if (data[i].callLog) {
          if (data[i].callLog.hangUpSide == 0) {
            hangSide = 'تماس گیرنده';
          } else if (data[i].callLog.hangUpSide == 1) {
            hangSide = 'پاسخ دهنده';
          } else {
            hangSide = '-';
          }
        }
        this.tableItems.push({
          date: date,
          from: data[i].callLog && data[i].callLog.callerId ? data[i].callLog.callerId : '-',
          callLogId: data[i].callLog && data[i].callLog.id ? data[i].callLog.id : null,
          to: data[i].destination ? data[i].destination : '-',
          user: user,
          duration: this.msToTime(duration),
          waitTime: this.msToTime(duration1),
          status:
            data[i].callTag && data[i].callTag.persianTitle ? data[i].callTag.persianTitle : '-',
          hangSide: hangSide,
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      // this.$refs.pagination.page = 1;
      this.resetPageNumber();
      // this.getQCCallsReportFunction(
      //   this.searchFromDate,
      //   this.searchToDate,
      //   this.searchCallTagId,
      //   this.searchSource,
      //   this.searchDestination,
      //   this.searchUserId,
      //   this.pagination.Page,
      //   this.pagination.PageSize
      // );
    },
    resetPageNumber: function () {
      this.pagination = {
        ...this.pagination,
        PageNumber: 1,
      };
    },
    resetPageSize: function () {
      this.pagination = {
        PageNumber: 1,
        PageSize: 10,
      };
    },
    removeFilters: function () {
      this.searchCallTagId = null;
      this.searchDestination = '';
      this.searchSource = '';
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      // this.$refs.pagination.page = 1;
      this.resetPageNumber();

      // this.getQCCallsReportFunction(
      //   this.searchFromDate,
      //   this.searchToDate,
      //   this.searchCallTagId,
      //   this.searchSource,
      //   this.searchDestination,
      //   this.searchUserId,
      //   this.pagination.Page,
      //   this.pagination.PageSize
      // );
    },
    cancelSearch: function () {
      this.searchCallTagId = null;
      this.searchDestination = null;
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    stopMusic: function () {
      var sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
    setPagination: function (data) {
      this.callsTotalPages = data?.totalPages;
    },
  },
  watch: {
    pagination: {
      handler(currentVal) {
        this.getQCCallsReportFunction(
          this.searchFromDate,
          this.searchToDate,
          this.searchCallTagId,
          this.searchSource,
          this.searchDestination,
          this.searchUserId,
          currentVal.PageNumber,
          currentVal.PageSize,
        );
      },
      deep: true,
    },
    // "$store.state.userModule.successFlag": function (currentVal) {
    //   if (currentVal)
    //     this.getQCCallsReportFunction(
    //       this.tempSearchFromDate,
    //       this.tempSearchToDate,
    //       this.searchCallTagId,
    //       this.searchSource,
    //       this.searchDestination,
    //       this.searchUserId,
    //       this.pagination.Page,
    //       this.pagination.PageSize
    //     );
    // },
  },
};
